import axios from "axios";
import authHeader from "./auth-header";
import {toast} from "react-toastify";

class AuthService {
    logout() {
        localStorage.clear();
        localStorage.removeItem("error");
        localStorage.removeItem("user");
        localStorage.removeItem('auth');
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    getAccessToken() {
        const user = this.getCurrentUser();

        if (user && user.access_token) {
            return user.access_token;
        }

        return null;
    }

    getUser() {
        return JSON.parse(localStorage.getItem('auth'));
    }

    getSubscription() {
        try {
            return JSON.parse(localStorage.getItem('auth')).subscription;
        } catch (e) {
            return null;
        }
    }

    getReserved() {
        try {
            return JSON.parse(localStorage.getItem('auth')).reserved;
        } catch (e) {
            return null;
        }
    }
    getSupportElements(){
        try {
            return JSON.parse(localStorage.getItem('auth')).support_elements;
        } catch (e) {
            return null;
        }
    }
    getLatestSubscription() {
        try {
            return JSON.parse(localStorage.getItem('auth')).latest_subscription;
        } catch (e) {
            return null;
        }
    }

    successAuth(data) {
        localStorage.setItem("user", JSON.stringify(data));
    }
    getHasActiveMeal() {
        try {
            return JSON.parse(localStorage.getItem('user'))?.has_active_meal;
        } catch (e) {
            return null;
        }
    }
    getHasWeighing(){
        try{
            return JSON.parse(localStorage.getItem('user'))?.has_weighing
        }catch(e){
            return null;
        }
    }
}

export default new AuthService();
